'use client'

import {useEffect} from 'react'
import {Slideout} from '@local/ui/components'

export const Calendly = ({
	isOpen,
	onClose,
}: {
	isOpen: boolean;
	onClose: () => void;
}) => {
	useEffect(() => {
		const head = document.querySelector('head')
		const script = document.createElement('script')
		script.setAttribute(
			'src',
			'https://assets.calendly.com/assets/external/widget.js',
		)
		head?.appendChild(script)
	}, [])

	return (
		<Slideout
			isOpen={isOpen}
			variant='right'
			onClickClose={onClose}
			className='bg-white relative !px-0 z-99 overflow-y-scroll'>
			<div
				className='calendly-inline-widget '
				data-url='https://calendly.com/team-kaer/discovery-call'
				style={{minWidth: '320px', height: '1200px'}} />
		</Slideout>
	)
}
